<template>
  <div>
    <vs-progress v-if="loadedRatio != 1" :height="6" :percent="Math.floor(loadedRatio * 100)" color="success"></vs-progress>
		<div id="paging-buttons_container">
      <div id="prev-btn_container">
        <vs-button id="prev-page-btn" @click="page > 1 ? prevPage():''" size="large" radius icon-pack="feather" v-show="page != 1" icon="icon-arrow-left" />
        </div>
      <div id="next-btn_container">
        <vs-button id="next-page-btn" @click="page <= numPages-1 ? nextPage() : '' " size="large" radius icon-pack="feather" v-show="page != numPages" icon="icon-arrow-right" />
      </div>
      <div style="position:relative;min-height:100%;">
        <div style="position: absolute;bottom: 155px;left: 0;right: 0;">
          <vx-card id="paging-card">
            <div class="vx-row mx-auto">
              <div class="vx-col w-full">
                <div class="flex justify-center" style="align-items: baseline;">
                  <vs-input size="small" type="number" style="width:60px" v-model.number="page" />
                  <span class="text-white" style="font-size: 12pt;align-self: flex-end;">&nbsp;/&nbsp;<strong>{{numPages}}</strong></span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
		<div>
      <pdf id="pdf-element" ref="pdf" style="" :src="src" :page="page" :rotate="rotate" @progress="loadedRatio = $event" @error="error" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  data() {
    return {
      src: "",
			numPages: undefined,
			loadedRatio: 0,
			page: 1,
			rotate: 0,
    };
  },
  methods: {
		error: function(err) {

			console.log(err);
    },
    prevPage() {
      this.scrollToNavbar();
      this.page = this.page - 1;
    },
    nextPage() {
      this.scrollToNavbar();
      this.page = this.page + 1;
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
  },
  mounted() {
    this.src = this.$route.query.url;
  }
};
</script>

<style lang="scss">
  
</style>
